import React, { useEffect, useState } from 'react';
import { styled } from '@glitz/react';
import ReviewViewModelLabels from 'Product/VariationViewModel+ReviewViewModelLabels.type';
import ReviewCard, { Review } from './ReviewCard';
import { ResponsiveSize, TextLabel, Text } from 'Shared/SharedComponents/atoms/Typography';
import Reviews from 'Product/Reviews';
import connect from 'Shared/connect';
import { createGridClasses, createOffsetGridClassLarge } from 'Shared/grid';
import * as style from 'Shared/Style';

export type ReviewLabelsPropType = ReviewViewModelLabels & { reviews: string };

type PropType = {
  itemNumbers: string[];
  reviewLabels: ReviewLabelsPropType;
  reviewsSummary: ReviewsSummary;
  apiKey: string;
  apiId: string;
  isCompact: boolean;
  recalculateHeight: () => void;
};

type ReviewsSummary = {
  score: number;
  count: number;
};

type ReviewLink = {
  href: string;
  rel: string;
}

const SummaryWrap = styled.div({
  alignItems: 'start'
})

const Data = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',

  ['@media ' + style.mediaUpToLarge]: {
    marginBottom: '40px',
  },
})

const ReviewsWrap = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px;',
})

const ShowMore = styled.span({
  marginTop: '16px',
  cursor: 'pointer',
  color: style.colors.monochrome.a11ygrey,
  ['@media ' + style.mediaMinLarge]: {
    ':hover': {
      color: style.colors.monochrome.black,
    },
  },
})

const TopContent = styled.div({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
})


function ReviewsContent({ reviewsSummary, itemNumbers, reviewLabels, apiKey, apiId, isCompact, recalculateHeight }: PropType) {
  const [customerReviews, setCustomerReviews] = useState<Review[]>([]);
  //const [numberOfReviewsShown, setNumberOfReviewsShown] = useState<number>(2);
  const [nextPage, setNextPage] = useState<number>(1);
  const [showMore, setShowMore] = useState<boolean>(false);

  const baseUrl = `https://api.trustpilot.com/v1/product-reviews/business-units/${apiId}/reviews?apikey=${apiKey}&sku=${itemNumbers?.toString()}&perPage=2&page=`;

  function fetchNextPage() {
    fetch(baseUrl + nextPage)
      .then((reviewsResponse) => reviewsResponse.json())
      .then((reviewsJson) => {
        setCustomerReviews((reviews) => reviews.concat(reviewsJson.productReviews));

        setShowMore(false);
        const links = reviewsJson.links as ReviewLink[];
        if (links && links.length > 0) {
          const next = links.find(x => x.rel === 'next-page');
          if (next) {
            setShowMore(true);
            setNextPage((next) => {
              return next + 1;
            });
          }
        }
      });
  }

  function fetchReviewData() {
    if (apiKey) {
      fetch(
        baseUrl + 1,
      )
        .then((reviewsResponse) => reviewsResponse.json())
        .then((reviewsJson) => {
          setCustomerReviews(reviewsJson.productReviews);
          const links = reviewsJson.links as ReviewLink[];
          if (links && links.length > 0) {
            const next = links.find(x => x.rel === 'next-page');
            if (next) {
              setShowMore(true);
              setNextPage(2);
            }
          }
        });
    }
  }

  useEffect(() => {
    if (itemNumbers) {
      fetchReviewData();
    }
  }, [itemNumbers]);

  useEffect(() => {
    recalculateHeight();
  }, [customerReviews]);

  return (
    reviewsSummary && (
      <SummaryWrap className="grid subgrid-11">
        <Data className={createGridClasses(12, 5)}>
          <TopContent>
            <Text fontSize={ResponsiveSize.D96_M48}>{reviewsSummary.score}</Text>
            <div>
              <Reviews
                labels={{ reviews: reviewLabels.reviews }}
                rating={reviewsSummary.score}
                numberOfReviews={reviewsSummary.count}
                flexColumn
              />
            </div>
          </TopContent>
        </Data>
        <ReviewsWrap className={createGridClasses(12, 5, createOffsetGridClassLarge(6))}>
          {customerReviews
            //.filter((_review, index) => index < numberOfReviewsShown)
            .map((review, index) => {
              return (
                <ReviewCard
                  key={`review_card-${index}`}
                  review={review}
                  reviewLabels={reviewLabels}
                  isCompact={isCompact}
                />
              );
            })}
          {showMore && (
            <ShowMore
              onClick={() => {
                fetchNextPage();
                // if (customerReviews.length <= numberOfReviewsShown) {

                // } else {
                //   recalculateHeight();
                // }
                // setNumberOfReviewsShown((currentNumber) => currentNumber + 2);
              }}
            >
              <TextLabel>{reviewLabels.viewMore}</TextLabel>
            </ShowMore>
          )}
        </ReviewsWrap>
      </SummaryWrap>
    )
  );
}

export default connect((state) => ({
  apiKey: state.appShellData.apiKeys.trustpilotApiKey,
  apiId: state.appShellData.apiKeys.trustpilotUnitId,
}))(ReviewsContent);
